var map = {
	"./recipe1.png": 1638,
	"./recipe10.png": 1639,
	"./recipe2.png": 1640,
	"./recipe3.png": 1641,
	"./recipe4.png": 1642,
	"./recipe5.png": 1643,
	"./recipe6.png": 1644,
	"./recipe7.png": 1645,
	"./recipe8.png": 1646,
	"./recipe9.png": 1647,
	"./thumb_recipe1.png": 1648,
	"./thumb_recipe10.png": 1649,
	"./thumb_recipe2.png": 1650,
	"./thumb_recipe3.png": 1651,
	"./thumb_recipe4.png": 1652,
	"./thumb_recipe5.png": 1653,
	"./thumb_recipe6.png": 1654,
	"./thumb_recipe7.png": 1655,
	"./thumb_recipe8.png": 1656,
	"./thumb_recipe9.png": 1657
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 669;



//////////////////
// WEBPACK FOOTER
// ./app/assets/images/activity_page/recipes nonrecursive \.png$
// module id = 669
// module chunks = 3